/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import { AccessComponentKeyEnum } from '../../../modules/role/constants/guard/guardConstants';
import { guardComponentType } from '../../../modules/role/reducer/guardReducer';
import { ExternalRoutePath } from '../../../routes/constants/externalRoutes';
import { CLIENT_ID, RoutePath } from '../../../routes/constants/routesConstants';
import { stringFormat } from '../../../utils/stringFormat';

export const getPageAccountInfoUrl = (guardTypes: guardComponentType, id: string) =>
    guardTypes[AccessComponentKeyEnum.PageAccountInfoGeneral]
        ? RoutePath.accountInfo.replace(CLIENT_ID, id)
        : stringFormat(ExternalRoutePath.account, id);

export const getPageAccountInfoUrlRegex = (guardTypes: guardComponentType) =>
    guardTypes[AccessComponentKeyEnum.PageAccountInfoGeneral]
        ? RoutePath.accountInfo
        : ExternalRoutePath.account;

export const isPageAccountInfoUrlExternal = (guardTypes: guardComponentType) =>
    !guardTypes[AccessComponentKeyEnum.PageAccountInfoGeneral];
